import * as React from 'react';

import BackgroundLeftImage from 'assets/vote-page/background-left.svg?url';
import BackgroundRightImage from 'assets/vote-page/background-right.svg?url';

import { Background, Description, Illustration, Title } from './VotingPageHero.styled';

export type VotingPageKind = 'markets' | 'governance';

const VotingPageHero = ({ kind }: { kind: VotingPageKind }) => (
    <Background $kind={kind}>
        <Title $kind={kind}>
            {kind === 'markets'
                ? 'Vote with ICE to Support Stellar Markets'
                : 'Aquarius Governance'}
        </Title>
        <Description>
            {kind === 'markets'
                ? 'Lock your AQUA to mint ICE and vote on-chain. Your votes decide how AQUA emissions are distributed — and can earn you voting rewards along the way.'
                : 'Aquarius protocol is governed by DAO voting with ICE tokens. Vote and participate in discussions to shape the future of Aquarius.'}
        </Description>
        <Illustration src={BackgroundLeftImage} alt="" aria-hidden="true" />
        <Illustration src={BackgroundRightImage} alt="" aria-hidden="true" $right />
    </Background>
);

export default VotingPageHero;
